// ======================================================================
// File Name       : UserAttributeDetailConfirmContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Form } from 'react-bootstrap';

class UserAttributeDetailConfirmContainer extends Component {
  render() {
    const { editingUserAtribute } = this.props;

    return (
      <div>
        {this.props.reverseBackground && <div />}
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={12} className={this.props.titleClass}>
            自由記述領域
          </Col>
        </Form.Group>
        {Object.keys(editingUserAtribute).map((keyNum) => {
          const value = editingUserAtribute[keyNum];
          return value &&
          <Form.Group key={keyNum} className="form-info">
            <Col
              as={Form.Label}
              sm={this.props.leftSize}
              className={this.props.leftClass}
            >
              自由記述領域{keyNum}
            </Col>
            <Col as={Form.Label} sm={this.props.rightSize}>{value}</Col>
          </Form.Group>;
        })}
      </div>
    );
  }
}

UserAttributeDetailConfirmContainer.propTypes = {
  editingUserAtribute: PropTypes.shape().isRequired,
  reverseBackground: PropTypes.bool,
  leftSize: PropTypes.number,
  rightSize: PropTypes.number,
  titleClass: PropTypes.string,
  leftClass: PropTypes.string,
};

UserAttributeDetailConfirmContainer.defaultProps = {
  reverseBackground: false,
  leftSize: 3,
  rightSize: 9,
  titleClass: '',
  leftClass: '',
};

const mapStateToProps = state => ({ editingUserAtribute: state.userAttribute.editingUserAtribute });
export default connect(mapStateToProps)(UserAttributeDetailConfirmContainer);
